import React from 'react'

export default function PageTitle({ children, className = '' }) {
  return <h1 className={`text-2xl font-bold text-gray-800 mb-3 mt-3 ${className}`}>{children}</h1>
}
